import script from "./TagSmartContract.vue?vue&type=script&setup=true&lang=js"
export * from "./TagSmartContract.vue?vue&type=script&setup=true&lang=js"

import "./TagSmartContract.vue?vue&type=style&index=0&id=d10f019e&lang=scss"

const __exports__ = script;

export default __exports__